import { useCallback } from 'react'
import { router } from 'expo-router'

interface IUseImageViewerNavigationParams {
  enrollmentId: string
  courseId: string
  courseContentsId: string
  isExtraContent?: boolean
}

export function useImageViewerNavigation({
  enrollmentId,
  courseId,
  courseContentsId,
  isExtraContent = false,
}: IUseImageViewerNavigationParams) {
  const handleNavigateToImageViewer = useCallback(() => {
    if (isExtraContent) {
      router.navigate(`/image_viewer`)
      return
    }

    router.navigate(
      `/enrollments/${enrollmentId}/courses/${courseId}/online_course/course_contents/${courseContentsId}/image_viewer`,
    )
  }, [courseContentsId, courseId, enrollmentId, isExtraContent])

  return {
    handleNavigateToImageViewer,
  }
}
